"use client";

import { useOmniSearch } from "./context";
import { ContentTypeLabels } from "./content_types";
import type { SearchResult } from "./api";

type Props = {
  results: SearchResult[];
};

export function Results({ results }: Props) {
  const { closeSearch } = useOmniSearch();

  if (!results.length) {
    return <p className="font-bold">What do you want to learn today?</p>;
  }

  return (
    <div className="flex flex-col gap-[5px] overflow-y-auto">
      {results.map((r) => (
        <a
          key={r.url}
          href={r.url}
          className="block p-[10px] rounded-[var(--iq-border-radius-md)] bg-white font-bold transition-colors duration-100 hover:bg-iq-orange-light"
          onClick={closeSearch}
        >
          {r.title}
          <div className="text-[13px] font-normal text-iq-grey-medium">
            {ContentTypeLabels[r.content_type]}
          </div>
        </a>
      ))}
    </div>
  );
}
